import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cn } from "./cn.js";

const variants = cva("yatta-button", {
  variants: {
    variant: {
      primary: "yatta-button-primary",
      secondary: "yatta-button-secondary",
      ghost: "yatta-button-ghost",
      danger: "yatta-button-danger",
    },
    size: {
      sm: "yatta-button-sm",
      md: "yatta-button-md",
      lg: "yatta-button-lg",
    },
  },
  defaultVariants: { variant: "primary", size: "md" },
});

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof variants> {}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, type = "button", ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cn(variants({ variant, size }), className)}
      {...props}
    />
  ),
);
Button.displayName = "Button";
